
import React from "react";
import TagItem from "./TagItem";
import { Tag } from "@/hooks/useTags";

interface TagWithSelectionState extends Tag {
  isSecondarySelected: boolean;
}

interface TagListProps {
  tags: TagWithSelectionState[];
  isLoading: boolean;
  dropTargetId: string | null;
  locationPathname: string;
  isTagHidden: (tagId: string) => boolean;
  onToggleSelection: (tagId: string, e: React.MouseEvent) => void;
  onEditTag: (tag: Tag, e: React.MouseEvent) => void;
  onDeleteTag: (tag: Tag, e: React.MouseEvent) => void;
  onToggleTagVisibility: (tag: Tag, e: React.MouseEvent) => void;
  onTagDragOver: (e: React.DragEvent, tagId: string) => void;
  onTagDragLeave: () => void;
  onTagDrop: (e: React.DragEvent, tagId: string, tagName: string) => void;
}

const TagList: React.FC<TagListProps> = ({
  tags,
  isLoading,
  dropTargetId,
  locationPathname,
  isTagHidden,
  onToggleSelection,
  onEditTag,
  onDeleteTag,
  onToggleTagVisibility,
  onTagDragOver,
  onTagDragLeave,
  onTagDrop
}) => {
  if (isLoading) {
    return (
      <div className="py-2 text-center text-sm text-gray-500">
        Loading tags...
      </div>
    );
  }

  if (tags.length === 0) {
    return (
      <div className="py-2 text-center text-sm text-gray-500">
        No tags created yet
      </div>
    );
  }

  return (
    <ul className="w-full space-y-2 py-1 px-1">
      {tags.map((tag) => (
        <TagItem
          key={`tag-${tag.id}`}
          tag={tag}
          isActive={locationPathname === `/tag/${tag.id}`}
          isHidden={isTagHidden(tag.id)}
          dropTargetId={dropTargetId}
          onToggleSelection={onToggleSelection}
          onEdit={onEditTag}
          onDelete={onDeleteTag}
          onToggleVisibility={onToggleTagVisibility}
          onDragOver={onTagDragOver}
          onDragLeave={onTagDragLeave}
          onDrop={onTagDrop}
        />
      ))}
    </ul>
  );
};

export default TagList;
